import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function Card({
  children,
  className = '',
  delay = 0
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay
  }} className={`bg-[#151b33] rounded-2xl border border-white/5 p-6 shadow-xl ${className}`} data-id="element-297">
      {children}
    </motion.div>;
}